<template>
	<div class="resetemailproving">
			<v-header :goBackaf='true'></v-header>
			<span class="title">{{$t('forgetpassword.resetpassword')}}</span>
			<div class="pro_pic">
				<img :src="pro_pic" alt=" "/>
			</div>
			<el-main>
				<div class="last">
					<img src="../../../static/img/gou.png" alt=" " />
					<p>{{$t('resetemailproving.lastone')}}<br /><span>{{email}}</span></p></div>
				<div class="text">
					{{$t('resetemailproving.lasttwo')}}
				</div>
				<a class="enter_email" :href='href'  target="_blank">{{$t('resetemailproving.resetPsdEmail')}}</a>
			</el-main>
	</div>
</template>

<script>
import store from "../../store/store.js";
import Qs from "qs";
import axios from "axios";
import header from '../../components/header';
export default{
	name:"emailproving",
	data(){
		return{
			pro_pic:"../../../static/img/dp-logo.jpg",
			email:"",
			href:""
		}
	},
	mounted(){
		this.email=this.$route.query.email
		console.log(this.href)
		this.resetemailproving()
	},
	components:{
        "v-header":header
    },
	methods:{
		resetemailproving(){
			setTimeout(()=>{
				var hash = {
				'qq.com': 'http://mail.qq.com',
				'gmail.com': 'http://mail.google.com',
				'sina.com': 'http://mail.sina.com.cn',
				'163.com': 'http://mail.163.com',
				'126.com': 'http://mail.126.com',
				'yeah.net': 'http://www.yeah.net/',
				'sohu.com': 'http://mail.sohu.com/',
				'tom.com': 'http://mail.tom.com/',
				'sogou.com': 'http://mail.sogou.com/',
				'139.com': 'http://mail.10086.cn/',
				'hotmail.com': 'http://www.hotmail.com',
				'live.com': 'http://login.live.com/',
				'live.cn': 'http://login.live.cn/',
				'live.com.cn': 'http://login.live.com.cn',
				'189.com': 'http://webmail16.189.cn/webmail/',
				'yahoo.com.cn': 'http://mail.cn.yahoo.com/',
				'yahoo.cn': 'http://mail.cn.yahoo.com/',
				'eyou.com': 'http://www.eyou.com/',
				'21cn.com': 'http://mail.21cn.com/',
				'188.com': 'http://www.188.com/',
				'foxmail.com': 'http://www.foxmail.com',
				'outlook.com': 'http://www.outlook.com'
			}
			var _mail = this.email.split('@')[1];    //获取邮箱域
			// console.log("获取邮箱后缀：",_mail)
			for (var j in hash){
				if(j == _mail){
					// $(".js_login_mail").show().attr("href", hash[_mail]);    //替换登陆链接
					this.href=hash[_mail]
					// console.log("跳转邮箱：",this.href)
				}
			}
			},500)

		}
	}
}
</script>

<style scoped>
	/*头部*/
	.title{
		text-align: center;
		font-size: .75rem;
		display: block;
		color: #828282;
	}
	.logo{
		text-align: center;
		width: 50%;
		margin: 0 auto;
		margin-top: 8px;
	}
	.logo img{
		width: 100%;
	}
	.pro_pic{
		width: 100%;
		text-align: center;
		margin: 1rem 0;
	}
	/*主体信息*/
	.el-main{
		width: 20rem;
		margin: 0 auto;
		padding: 0 20px;
	}
	.last{
		line-height: 1.6rem;
		display: flex;
	}
	.last p{
		font-size: 0.9rem;
		font-weight: bold;
		align-items: center;
		margin-left: 10px;
		color: #393939;
		font-family: "黑体";
	}
	.last p span{
		color: #095196;
		font-family: arial;
	}
	.last img{
		width: 1.6rem;
		height: 1.6rem;
		align-items: center;
	}
	.text{
		color: #8b8b8b;
		font-size: 0.9rem;
		line-height: 1.6rem;
		margin-top: 20px;
		font-family: "黑体";
	}
	.enter_email{
		margin-top: 20px;
		width: 100%;
		display: block;
		height: 2.8rem;
		line-height: 2.8rem;
		background: #095196;
		color: #FFFFFF;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/m_page/login/resetemailproving.vue